var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconamoonSearchLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.5002L16.657 17.1572M16.657 17.1572C17.3998 16.4143 17.9891 15.5324 18.3912 14.5618C18.7932 13.5911 19.0002 12.5508 19.0002 11.5002C19.0002 10.4496 18.7932 9.40929 18.3912 8.43866C17.9891 7.46803 17.3998 6.58609 16.657 5.84321C15.9141 5.10032 15.0321 4.51103 14.0615 4.10898C13.0909 3.70693 12.0506 3.5 11 3.5C9.94936 3.5 8.90905 3.70693 7.93842 4.10898C6.96779 4.51103 6.08585 5.10032 5.34296 5.84321C3.84263 7.34354 2.99976 9.37842 2.99976 11.5002C2.99976 13.622 3.84263 15.6569 5.34296 17.1572C6.84329 18.6575 8.87818 19.5004 11 19.5004C13.1217 19.5004 15.1566 18.6575 16.657 17.1572Z",
    stroke: "#222F3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonSearchLight);
export default __webpack_public_path__ + "static/media/iconamoon_search-light.0996cd71823b03d2c14e56279e75373d.svg";
export { ForwardRef as ReactComponent };